/* Datos para factura en el carrito (paridad MX, tarea B5).
   <tbl-cart-invoice> envuelve los inputs attributes[NIT] y
   attributes[Nombre para factura] del snippet timberland-cart-summary.
   Al escribir (debounce 400 ms) o al salir del campo se hace POST a
   /cart/update.js con ambos atributos. No se re-renderiza nada desde aquí
   para no perder el foco: cuando cart.js reemplace el pie del carrito, el
   elemento nuevo trae los valores de cart.attributes. */
(() => {
  if (customElements.get('tbl-cart-invoice')) return;

  const NIT = 'NIT';
  const NOMBRE = 'Nombre para factura';

  class TblCartInvoice extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.ultimo = null;
      this.onInput = this.onInput.bind(this);
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('input', this.onInput);
      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('input', this.onInput);
      this.removeEventListener('change', this.onChange);
      if (this.timer) {
        // El drawer re-renderiza el pie en cada actualización: si había un
        // guardado en la ventana de debounce, se envía ahora (sendBeacon).
        window.clearTimeout(this.timer);
        this.timer = null;
        this.guardar(true);
      }
    }

    valores() {
      const nit = this.querySelector('input[name="attributes[NIT]"]');
      const nombre = this.querySelector('input[name="attributes[Nombre para factura]"]');
      return {
        [NIT]: nit ? nit.value.trim() : '',
        [NOMBRE]: nombre ? nombre.value.trim() : '',
      };
    }

    onInput(event) {
      if (!event.target.matches('input')) return;
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.guardar();
      }, 400);
    }

    onChange(event) {
      if (!event.target.matches('input')) return;
      window.clearTimeout(this.timer);
      this.timer = null;
      this.guardar();
    }

    guardar(beacon = false) {
      const attributes = this.valores();
      const firma = JSON.stringify(attributes);
      if (firma === this.ultimo) return;
      this.ultimo = firma;

      const url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
      const cuerpo = JSON.stringify({ attributes });
      if (beacon && navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([cuerpo], { type: 'application/json' }));
        return;
      }
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: cuerpo,
      }).catch(() => {
        // Sin red: los inputs llevan form="…" y viajan con el submit de checkout.
        this.ultimo = null;
      });
    }
  }

  customElements.define('tbl-cart-invoice', TblCartInvoice);
})();
